import { render, staticRenderFns } from "./OnlineRequests.vue?vue&type=template&id=1637c96e&scoped=true&"
import script from "./OnlineRequests.vue?vue&type=script&lang=js&"
export * from "./OnlineRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1637c96e",
  null
  
)

export default component.exports